import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { AuthSurface } from "@/components/auth";
import { MfaDialog } from "@/components/mfa";
import { Button } from "@/components/ui";
import { useSelfScheduleContext } from "@/contexts/self-schedule-provider";
import { usePatientVerification } from "@/hooks/self-schedule/use-patient-verification";
import { cx } from "@/lib/tailwind-utils";
import { selfScheduleQueryOptions } from "@/api/check-in/self-schedule/self-schedule-query";
import { PatientType, SelfScheduleStep } from "@/stores/self-schedule-store";
export const PatientTypeStep = () => {
  const $ = _c(43);
  const {
    isSigningIn,
    setIsSigningIn,
    patient
  } = usePatientVerification();
  const {
    setPatientType,
    firstStep
  } = useSelfScheduleContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...selfScheduleQueryOptions.frontPage(),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: tenantName
  } = useQuery(t0);
  let t1;
  let t2;
  if ($[1] !== patient || $[2] !== setPatientType) {
    t1 = () => {
      if (patient) {
        setPatientType(patient.patientStatus);
      }
    };
    t2 = [patient, setPatientType];
    $[1] = patient;
    $[2] = setPatientType;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = firstStep === SelfScheduleStep.PATIENT_TYPE ? "motion-opacity-in-0 motion-duration-1000" : "motion-scale-in-105 motion-opacity-in-85";
  let t4;
  if ($[5] !== t3) {
    t4 = cx("mx-auto mt-12 flex max-w-md flex-col gap-2", "motion-ease-spring-bouncy", t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="-mb-2">Welcome!</p>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== tenantName) {
    t6 = <h1>Have you visited {tenantName} before?</h1>;
    $[8] = tenantName;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isSigningIn || $[11] !== setIsSigningIn) {
    t7 = () => {
      setIsSigningIn(!isSigningIn);
    };
    $[10] = isSigningIn;
    $[11] = setIsSigningIn;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isSigningIn || $[14] !== t7) {
    t8 = <MfaDialog open={isSigningIn} onOpenChange={t7} surface={AuthSurface.SELF_SCHEDULE} title="Welcome back!" description="Enter your phone number to sign in to your account." tAndSFooterText="signing in to your account" />;
    $[13] = isSigningIn;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cx("hover:!bg-primary hover:!text-primary-foreground", "motion-preset-slide-right-sm");
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== setIsSigningIn) {
    t10 = () => {
      setIsSigningIn(true);
    };
    $[17] = setIsSigningIn;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span>I'm an existing patient</span>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10) {
    t12 = <Button variant="secondary" className={t9} onClick={t10}>{t11}</Button>;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = cx("hover:!bg-primary hover:!text-primary-foreground", "motion-preset-slide-right-sm motion-delay-100");
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== setPatientType) {
    t14 = () => {
      setPatientType(PatientType.NEW);
    };
    $[23] = setPatientType;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span>I'm a new patient</span>;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14) {
    t16 = <Button variant="secondary" className={t13} onClick={t14}>{t15}</Button>;
    $[26] = t14;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== setPatientType) {
    t17 = () => {
      setPatientType(PatientType.ALL);
    };
    $[28] = setPatientType;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = cx("hover:!bg-transparent hover:text-foreground", "motion-preset-slide-right-sm", "text-caption text-muted-foreground");
    t19 = <span>I'm not sure</span>;
    $[30] = t18;
    $[31] = t19;
  } else {
    t18 = $[30];
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t17) {
    t20 = <Button variant="ghost" onClick={t17} className={t18}>{t19}</Button>;
    $[32] = t17;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t12 || $[35] !== t16 || $[36] !== t20 || $[37] !== t8) {
    t21 = <div className="mt-2 flex flex-col gap-2">{t8}{t12}{t16}{t20}</div>;
    $[34] = t12;
    $[35] = t16;
    $[36] = t20;
    $[37] = t8;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t21 || $[40] !== t4 || $[41] !== t6) {
    t22 = <div data-testid="step-patient-type" className={t4}>{t5}{t6}{t21}</div>;
    $[39] = t21;
    $[40] = t4;
    $[41] = t6;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  return t22;
};
function _temp(data) {
  return data?.tenantName;
}